import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
//
import { StyledLabel } from './styles';

// ----------------------------------------------------------------------

const Label = forwardRef(({ children, color = 'default', variant = 'soft', startIcon, endIcon, dot, sx, ...other }, ref) => {
    const theme = useTheme();

    const iconStyle = {
        "width": 16,
        "height": 16,
        '& svg, img': { width: 1, height: 1, objectFit: 'cover' },
    };

    // currentColor so the dot always inherits the label's resolved text colour,
    // which is already contrast-checked against the label's own background.
    const dotStyle = {
        "width": 6,
        "height": 6,
        "flexShrink": 0,
        "marginRight": theme.spacing(0.75),
        "borderRadius": '50%',
        ...(dot === 'ring'
            ? { border: '1.5px solid currentColor' }
            : { backgroundColor: 'currentColor' }),
    };

    return (
        <StyledLabel
            ref={ref}
            component="span"
            ownerState={{ color, variant }}
            sx={{
                ...((startIcon || dot) && { pl: 0.75 }),
                ...(endIcon && { pr: 0.75 }),
                ...sx,
            }}
            theme={theme}
            {...other}
        >
            {dot && <Box component="span" sx={dotStyle} />}

            {startIcon && <Box sx={{ mr: 0.75, ...iconStyle }}> {startIcon} </Box>}

            {children}

            {endIcon && <Box sx={{ ml: 0.75, ...iconStyle }}> {endIcon} </Box>}
        </StyledLabel>
    );
});

Label.propTypes = {
    sx: PropTypes.object,
    endIcon: PropTypes.node,
    children: PropTypes.node,
    startIcon: PropTypes.node,
    // 'solid' reads as terminal, 'ring' as still in motion.
    dot: PropTypes.oneOf(['solid', 'ring']),
    variant: PropTypes.oneOf(['filled', 'outlined', 'ghost', 'soft']),
    color: PropTypes.oneOf(['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error']),
};

export default Label;
